import styled from 'styled-components'
import {useEffect, useState} from 'react'
import icoMultiply from '../../../assets/icons/multiply.svg'
import {Left, Right} from './Item'
import { Box, Flex } from '@chakra-ui/react'

function ThirdStepItem({id, quantity, items, children}) {
    const [item, setItem] = useState(undefined)
    const [parent, setParent] = useState(undefined)

    useEffect(() => {
        const found = items.find(element => element.id === Number(id))
        setItem(found)

        if (found && found.parent_id !== null) {
            const parent = items.find(element => element.id === found.parent_id)
            setParent(parent)
        }
    }, [id, items])

    const renderTitle = () => {
        if (parent !== undefined) {
            return <>
                <div>{parent?.title}</div>
                <p>{item?.title}</p>
            </>
        }

        return <div>{item?.title}</div>
    }

    const renderChildren = () => {
        if (children === undefined || children === null) {
            return <></>
        }
        let childrenArray = Object.entries(children)
        if (childrenArray.length === 0) {
            return <></>
        }
        childrenArray = childrenArray.filter(([key, item]) => {
            return Object.entries(item).length > 0;
        });

        return childrenArray.map(([key, item]) => {
            return <Flex
                key={key}
                w="full"
                justifyContent="space-between"
                alignItems="center"
                direction={'column'}
                border={'1px solid #3F4041'}
                borderRadius={10}
                bg="#F4F4F4"
                px={4}
                py={1}
                mb={1}
                mt={1}
            >
                {Object.entries(item).map(([childId, data]) => {
                    return <Flex
                        key={childId}
                        justifyContent="space-between"
                        alignItems="center"
                        w="full"
                    >
                        <Box>{data.title}</Box>
                        <Multiply>
                            <img src={icoMultiply} alt='quantity' />
                            {data.quantity}
                        </Multiply>

                    </Flex>
                })}
            </Flex>
        });
    }

    return <Box display="flex" flexDirection="column" justifyContent="space-between" alignItems="center" my={4}>
        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" w="full">
            <Left>
                {renderTitle()}
            </Left>
            <Right>
                <Multiply>
                    <img src={icoMultiply} alt='quantity'/>
                    {quantity}
                </Multiply>
            </Right>
        </Box>
        {renderChildren()}
    </Box>
}

const Multiply = styled.div`
    display: flex;
    align-items: center;

    img {
        width: 10px;
        height: 10px;
        margin-right: 3px;
    }
`

export default ThirdStepItem;
